module.exports = require("@formatjs/intl-pluralrules/locale-data/de");